export default __webpack_public_path__ + "static/media/banners_raceweek_500_330x330.e972ef22.webp";